<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        Crear equipo /
        <router-link to="/tarjetas"
          ><a href="#">Regresar a equipos</a>
        </router-link>
      </div>
      <div class="panel-body">
        <div class="col-md-6">
          <div class="form-group">
            <label>Marca</label>
            <select class="form-control" v-model="marca">
              <option
                v-for="(option, index) in marcas"
                v-bind:value="option.id"
              >
                {{ option.marca }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Referencia</label>
            <input
              v-model="referencia"
              class="form-control"
              placeholder="Digite la referencia"
            />
          </div>
          <div class="form-group">
            <label>Bodega</label>
            <select class="form-control" v-model="bodega">
              <option value="BODEGA 1">BODEGA 1</option>
              <option value="BODEGA 2">BODEGA 2</option>
              <option value="BODEGA 2">BODEGA 3</option>
            </select>
          </div>
          <div class="form-group">
            <label>Cantidad</label>
            <input
              type="number"
              v-model="cantidad"
              class="form-control"
              placeholder="Digite la cantidad"
            />
          </div>

          <button
            @click="checkForm"
            style="width: 100%;"
            class="btn btn-primary"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
export default {
  name: 'crear-tarjeta',
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      marca: '',
      referencia: '',
      bodega: 'BODEGA 1TE',
      cantidad: null,
      marcas: [],
    };
  },
  created() {
    this.getMarcas();
  },
  mounted() {},
  methods: {
    checkForm() {
      if (!this.marca) {
        this.$noty.error('La marca es requerida');
      } else if (!this.referencia) {
        this.$noty.error('La referencia es requerida');
      } else if (!this.cantidad) {
        this.$noty.error('La cantidad es requerida');
      } else if (this.cantidad < 1) {
        this.$noty.error(
          'La cantidad debe ser un número mayor a cero'
        );
      } else {
        this.saveInformation();
      }
    },
    saveInformation() {
      this.loading = true;
      let data = {
        marcaId: this.marca,
        referencia: this.referencia.toUpperCase(),
        cantidad: this.cantidad,
        bodega: this.bodega,
      };
      ServiceApi.post('/tarjetas/create', data)
        .then(response => {
          if (response.data.status) {
            this.$noty.success('Tarjeta creada con éxito');
            this.loading = false;
            this.$router.push('/tarjetas');
          }
        })
        .catch(err => {
          console.log('EL ERROR:::', err);
          this.loading = false;
          this.$noty.error(
            'Ocurrio un error al crear la tarjeta, intente nuevamente o contacte el administrador'
          );
        });
    },
    onCancel() {},
    getMarcas() {
      this.loading = true;
      ServiceApi.get('/marcas/list')
        .then(response => {
          //console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.marcas = data;
          this.marca = data[0].id;
          if (!data.length)
            this.$noty.warning('No se encontraron marcas creadas');
          this.loading = false;
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar las marcas'
          );
          this.loading = false;
        });
    },
  },
};
</script>
